import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { ChertoExperiments } from 'constants/experiments'
import useExperiment from 'hooks/Experiments/useExperiment'

interface NonRefundableWording {
  treatmentDetail: string
  treatmentLabel: string
  isTreatment: boolean
}

function useNonRefundableWordingExperiment(isEligible: boolean): NonRefundableWording {
  const intl = useIntl()
  const { isAnyVariant } = useExperiment(ChertoExperiments.croNonRefundableAndNonAmendable, { canActivate: isEligible })

  return useMemo(() => {
    const isTreatment = isEligible && isAnyVariant

    return {
      isTreatment,
      treatmentDetail: intl.formatMessage({
        id: 'VyHD32GOF9SGwwoBdAjq',
        defaultMessage: 'Please note that ’Non-Refundable and Non-Amendable’ packages are guaranteed at the time of booking and not eligible for a refund or date change. Accordingly, please select your package carefully and take note of any cancellation policy applicable to your purchase.',
        description: 'Treatment modal body explaining the non-refundable and non-amendable package policy',
      }),
      treatmentLabel: intl.formatMessage({
        id: 'iEahFEcRVkTQgjxdC2Q8',
        defaultMessage: 'Non-Refundable and Non-Amendable',
        description: 'Treatment label for eligible accommodation rates that cannot be refunded or amended',
      }),
    }
  }, [intl, isAnyVariant, isEligible])
}

export default useNonRefundableWordingExperiment
